/* eslint-disable */
import React, {useEffect, useState} from 'react';
import {Col, Form, Modal, Row} from "react-bootstrap";
import hide_passwd from '../../assets/icons/hide_passwd.png'
import show_passwd from '../../assets/icons/show_passwd.png'
import success from '../../assets/icons/success.png'
import fail from '../../assets/icons/fail.png'
import DataTable from "react-data-table-component";
import del from "../../assets/icons/del.png";

export default function AddUser(props) {
    const initialState = {name: '', email: '', password: '', confirmPassword: ''}
    const [userData, setUserData] = useState(initialState);
    const [message, setMessage] = useState('')
    const [errors, setErrors] = useState(initialState)
    const [showPasswd, setShowPasswd] = useState(false)
    const [showConfirmPasswd, setShowConfirmPasswd] = useState(false)
    const [infoModalShow, setInfoModalShow] = useState(false)
    const [delModalShow, setDelModalShow] = useState(false)
    const [infoIcon, setInfoIcon] = useState(success)
    const [delUserId, setDelUserId] = useState('')
    const [users, setUsers] = useState([])
    const columns = [{
        name: '№',
        selector: row => row.no,
        width: "10%",
        compact: true,
        center: true,
        wrap: true
    }, {
        name: 'Имя пользователя',
        selector: row => row.name,
        sortable: true,
        width: "50%",
        compact: false,
        wrap: true
    }, {
        name: 'e-mail',
        selector: row => row.email,
        sortable: true,
        width: "40%",
        center: false,
        wrap: true
    }, {
        cell: (row) => <button onClick={() => {
            setDelModalShow(true)
            setDelUserId(row.id)
        }} className="btn delete-row-btn">
            <img src={del} alt='del'/></button>,
        button: true,
        width: "0",
        center: true,
    }]


    const getUsers = async () => {
        const user_response = await fetch('api/ManageUser/GetUsers', {
            headers: !props.token ? {} : {'Authorization': `Bearer ${props.token}`}
        })
        let users_full = await user_response.json()
        setUsers(users_full.map((user, i) => ({id: user.id, no: i + 1, name: user.name, email: user.email})))
    }

    function addUser(e) {
        e.preventDefault();
        if (errors.name === '' && errors.email === '' && errors.password === '' && errors.confirmPassword === '') {
            const newUser = {name: userData.name, email: userData.email, password: userData.password}
            fetch('api/manageUser/addUser', {
                method: 'POST',
                headers: !props.token ? {} : {
                    'Authorization': `Bearer ${props.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newUser)
            }).then((response) => {
                if (response.ok) {
                    setMessage('Пользователь успешно добавлен')
                    setInfoIcon(success)
                    setInfoModalShow(true)
                    setUserData(initialState)
                    getUsers()
                } else {
                    setMessage('Ошибка добавления пользователя')
                    setInfoIcon(fail)
                    setInfoModalShow(true)
                }
            })
        }
    }

    function infoModal(props) {
        return (
            <Modal show={props}
                   backdrop="true"
                   className='info-modal'
                   keyboard={false}
                   animation={false}
                   onHide={() => setInfoModalShow(false)}
                   centered>
                <Modal.Header>
                    <img src={infoIcon} alt='success'/>
                </Modal.Header>
                <Modal.Body>
                    <div className="message">{message}</div>
                </Modal.Body>
            </Modal>
        );
    }

    function checkEmailValid(value) {
        let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regEmail.test(value)) {
            return ('Некорректный email!')
        }
        return ''
    }

    function checkPasswdValid(value){
        if (value.length<5)
            return 'Пароль должен содержать минимум 5 символов!'
        else
            return ''
    }

    function delModal(props) {
        return (
            <Modal show={props}
                   backdrop="static"
                   className='ask-del-modal'
                   keyboard={false}
                   onHide={() => setDelModalShow(false)}
                   centered>
                <Modal.Header>
                    <Modal.Title>Вы действительно хотите удалить пользователя?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='btn-row'>
                        <Col>
                            <button className='confirm-btn' onClick={() => setDelModalShow(false)}>Нет</button>
                        </Col>
                        <Col>
                            <button className='confirm-btn' onClick={delUser}>Да</button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function delUser() {
        fetch('api/manageUser/deleteUser?id=' + delUserId, {
            method: 'DELETE',
            headers: !props.token ? {} : {'Authorization': `Bearer ${props.token}`}
        }).then((response) => {
            if (response.ok) {
                setMessage('Пользователь успешно удален')
                setInfoIcon(success)
                setDelModalShow(false)
                setInfoModalShow(true)
                getUsers()
            } else {
                setMessage('Ошибка удаления пользователя')
                setInfoIcon(fail)
                setDelModalShow(false)
                setInfoModalShow(true)
            }
        })
    }


    useEffect(() => {
        if (props.token !== '') {
            getUsers()
        }
    }, [props.token])

    useEffect(() => {
        setErrors({
            name: userData.name === '' ? 'Заполните поле!' : '',
            email: errors.email,
            password: errors.password,
            confirmPassword: errors.confirmPassword
        })
    }, [userData.name]);

    useEffect(() => {
        setErrors({
            name: errors.name,
            email: userData.email === '' ? 'Заполните поле!' : '',
            password: errors.password,
            confirmPassword: errors.confirmPassword
        })
    }, [userData.email])

    useEffect(() => {
        setErrors({
            name: errors.name,
            email: errors.email,
            password: userData.password === '' ? 'Заполните поле!' : '',
            confirmPassword: userData.confirmPassword !== userData.password ? 'Пароли не совпадают!' : ''
        })
    }, [userData.password]);

    useEffect(() => {
        setErrors({
            name: errors.name,
            email: errors.email,
            password: errors.password,
            confirmPassword: userData.confirmPassword === '' ? (userData.password !== '' ? 'Заполните поле!' : '') :
                (userData.confirmPassword !== userData.password ? 'Пароли не совпадают!' : '')
        })
    }, [userData.confirmPassword]);

    useEffect(() => {
        document.getElementById('passwd').type = showPasswd ? 'text' : 'password'
    }, [showPasswd])

    useEffect(() => {
        document.getElementById('passwd_confirm').type = showConfirmPasswd ? 'text' : 'password'
    }, [showConfirmPasswd])

    useEffect(() => {
        if (infoModalShow) {
            setTimeout(() => setInfoModalShow(false), 2000)
        }
    }, [infoModalShow])

    return <Row id='change-page-row'>
        <Col>
            {infoModal(infoModalShow)}
            {delModal(delModalShow)}
            <Row className="block-label">Добавить нового пользователя</Row>
            <Row className="back-block">
                <Form>
                    <Form.Group>
                        <Form.Label>Введите имя пользователя</Form.Label>
                        <Form.Control className={errors.name !== '' ? 'error' : ''} value={userData.name}
                                      onChange={(e) => {
                                          setUserData({
                                              name: e.target.value,
                                              email: userData.email,
                                              password: userData.password,
                                              confirmPassword: userData.confirmPassword
                                          })
                                      }} placeholder='имя пользователя'></Form.Control>
                        <span>{errors.name}</span>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Введите e-mail</Form.Label>
                        <Form.Control className={errors.email !== '' ? 'error' : ''} value={userData.email}
                                      onBlur={() => setErrors({
                                          name: errors.name,
                                          email: errors.email === '' ? checkEmailValid(userData.email) : errors.email,
                                          password: errors.password,
                                          confirmPassword: errors.confirmPassword
                                      })}
                                      onChange={(e) => {
                                          setUserData({
                                              name: userData.name,
                                              email: e.target.value,
                                              password: userData.password,
                                              confirmPassword: userData.confirmPassword
                                          })
                                      }} placeholder='e-mail'></Form.Control>
                        <span>{errors.email}</span>
                    </Form.Group>
                    <Form.Group className='passwd-form'>
                        <Form.Label>Введите пароль</Form.Label>
                        <Form.Control className={errors.password !== '' ? 'error' : ''} value={userData.password}
                                      type='password' placeholder='пароль'
                                      id='passwd'
                                      onBlur={() => setErrors({
                                          name: errors.name,
                                          email: errors.email,
                                          password: errors.password  === '' ? checkPasswdValid(userData.password) : errors.password,
                                          confirmPassword: errors.confirmPassword
                                      })}
                                      onChange={(e) => {
                                          setUserData({
                                              name: userData.name,
                                              email: userData.email,
                                              password: e.target.value,
                                              confirmPassword: userData.confirmPassword
                                          })
                                      }}/>
                        <button className='eye-btn' onClick={(e) => {
                            e.preventDefault()
                            setShowPasswd(!showPasswd)
                        }}><img src={showPasswd ? show_passwd : hide_passwd} alt='eye'/></button>
                        <span>{errors.password}</span>
                    </Form.Group>
                    <Form.Group className='passwd-form'>
                        <Form.Label>Повторите пароль</Form.Label>
                        <Form.Control className={errors.confirmPassword !== '' ? 'error' : ''}
                                      value={userData.confirmPassword}
                                      id='passwd_confirm'
                                      type='password' placeholder='пароль'
                                      onBlur={() => setErrors({
                                          name: errors.name,
                                          email: errors.email,
                                          password: errors.password,
                                          confirmPassword: errors.confirmPassword  === '' ? checkPasswdValid(userData.confirmPassword) : errors.confirmPassword
                                      })}
                                      onChange={(e) => {
                                          setUserData({
                                              name: userData.name,
                                              email: userData.email,
                                              password: userData.password,
                                              confirmPassword: e.target.value
                                          })
                                      }}/>
                        <button className='eye-btn' onClick={(e) => {
                            e.preventDefault()
                            setShowConfirmPasswd(!showConfirmPasswd)
                        }}><img src={showConfirmPasswd ? show_passwd : hide_passwd} alt='eye'/></button>
                        <span>{errors.confirmPassword}</span>
                    </Form.Group>
                    <button onClick={(e) => {
                        addUser(e)
                    }}>Сохранить
                    </button>
                </Form>
            </Row>
        </Col>
        <Col className='user-table-block'>
            <Row className="block-label">Список пользователей</Row>
            <Row>
                <DataTable
                    data={users}
                    columns={columns}
                    responsive={false}
                    highlightOnHover={true}
                    noDataComponent=''
                    customStyles={{
                        table: {
                            style: {
                                border: ' 1px solid #E2E4EF',
                                borderRadius: '10px',
                                marginBottom: '50px',
                                padding: '1px'
                            }
                        },
                        headRow: {
                            style: {
                                borderRadius: '10px 10px 0 0',
                            }
                        },
                        headCells: {
                            style: {
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '19px',
                                padding: '0',
                                justifyContent: 'center',
                                ':not(:nth-last-child(-n + 2))': {
                                    borderRight: '1px solid #E2E4EF'
                                }
                            }
                        },
                        rows: {
                            style: {
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '19px',
                                border: '0 !important',
                                minHeight: '40px!important',
                                ':last-of-type': {
                                    borderRadius: '0 0 10px 10px'
                                },
                                ':hover': {
                                    background: ' rgba(226, 228, 239, 0.3) !important',
                                    borderRadius: '10px',
                                },

                            }
                        },

                        cells: {
                            style: {
                                ':not(:first-of-type)': {
                                    paddingLeft: '30px !important',
                                },
                                ':last-of-type': {
                                    paddingLeft: '0!important'
                                },
                                border: '0',
                            },
                        },
                    }}
                />
            </Row>
        </Col>
    </Row>;
}
